import dynamic from 'next/dynamic';
import { Check } from '@phosphor-icons/react';
import { Box, List, ListItem, ListIcon, Text } from '@chakra-ui/react';
import { TodoList as Props } from '@/types';
import Heading from '../Heading';
import { rowGap } from '../ArticleLayout';

const Buttons = dynamic(() => import('../Buttons'));

const TodoList = ({ title, list, buttons }: Props) => (
  <Box
    borderRadius="lg"
    background="backgroundColor"
    boxShadow="sm"
    p={[7, null, 8]}
    mb={rowGap}
  >
    {title && (
      <Heading variant="h4" mb="4">
        {title}
      </Heading>
    )}
    {list && (
      <List spacing="3" mb="4">
        {list.map((item, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <ListItem
            fontSize="lg"
            display="flex"
            key={`${item.substring(0, 10)}-${i}`}
          >
            <ListIcon
              as={Check}
              weight="light"
              color="success.500"
              fontSize="1.5em"
              verticalAlign="middle"
            />
            <Text display="flex" flexWrap="wrap">
              {item}
            </Text>
          </ListItem>
        ))}
      </List>
    )}
    {buttons?.length ? <Buttons buttons={buttons} /> : null}
  </Box>
);

export default TodoList;
